import React, { FC } from "react";

export const HomeIcon: FC = () => (
  <svg
    width="2vw"
    height="2vw"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-label="Home match"
    role="img"
  >
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
  </svg>
);

export const AwayIcon: FC = () => (
  <svg
    width="2vw"
    height="2vw"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-label="Away match"
    role="img"
  >
    <path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 10-3 0V9L2 14v2l8-2.5V18l-2 1v1l3-.5 3 .5v-1l-2-1v-4l9 2.5z" />
  </svg>
);

export const NeutralIcon: FC = () => (
  <svg
    width="2vw"
    height="2vw"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-label="Neutral venue"
    role="img"
  >
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
  </svg>
);

